import { apiClient } from '@/shared/api';
import type { Order, PaginatedOrders, OrderAttribution, ComputedAttribution } from './types';
import type { Journey } from '@/features/journeys/types';

interface ListOrdersParams {
  page?: number;
  limit?: number;
  search?: string;
  attributed?: boolean | null;
}

interface BackendOrdersResponse {
  data: Order[];
  pagination: {
    page: number;
    limit: number;
    total: number;
    totalPages: number;
  };
  metrics: {
    totalOrders: number;
    totalAttributed: number;
    totalPending: number;
    totalRevenue: number;
    attributionRate: number;
  };
}

export const ordersApi = {
  list: async ({ page = 1, limit = 5, search, attributed }: ListOrdersParams = {}): Promise<PaginatedOrders> => {
    const params = new URLSearchParams();
    params.set('page', page.toString());
    params.set('limit', limit.toString());
    if (search) params.set('search', search);
    if (attributed !== null && attributed !== undefined) {
      params.set('attributed', attributed.toString());
    }
    const response = await apiClient.get<BackendOrdersResponse>(`/orders?${params}`);
    return {
      data: response.data || [],
      pagination: response.pagination || {
        page: 1,
        limit: limit,
        total: 0,
        totalPages: 0,
      },
      metrics: response.metrics || {
        totalOrders: 0,
        totalAttributed: 0,
        totalPending: 0,
        totalRevenue: 0,
        attributionRate: 0,
      },
    };
  },

  get: (id: string) =>
    apiClient.get<Order>(`/orders/${id}`),

  getJourney: (id: string) =>
    apiClient.get<Journey>(`/orders/${id}/journey`),

  updateAttribution: (id: string, data: OrderAttribution) =>
    apiClient.patch<Order>(`/orders/${id}/attribution`, data),

  getComputedAttribution: (orderId: string) =>
    apiClient.get<ComputedAttribution>(`/attributions/orders/${orderId}`),
};
